/**
 * Appends a non-file multipart part encoded as an `application/json` blob.
 *
 * Spring's `@RequestPart` resolver rejects text/plain and missing content-type
 * with 415 ("Content-Type 'application/octet-stream' is not supported"), so
 * every scalar or object part must go over the wire as JSON. The explicit
 * `${name}.json` filename prevents the browser from dropping the Blob's type
 * and defaulting back to `application/octet-stream`.
 *
 * String values are JSON-quoted (`"IMAGE"`, not `IMAGE`) so the BE sees a
 * valid JSON scalar.
 */
export function appendJsonPart(
  formData: FormData,
  name: string,
  value: unknown,
): void {
  const blob = new Blob([JSON.stringify(value)], { type: 'application/json' });
  formData.append(name, blob, `${name}.json`);
}
